import { useEffect, useState } from "react"
import { TablaRegistroHuesped } from "../../RegistroHuespedes.type"

// Maneja la fila seleccionada de la tabla del reporte para mostrarla en el sidebar de detalle.
// La fila seleccionada no se limpia al cerrar para que el contenido no desaparezca
// mientras corre la animación de salida del drawer.
const useRegistroHuespedesDetail = (rows?: TablaRegistroHuesped[]) => {
    const [selectedRow, setSelectedRow] = useState<TablaRegistroHuesped | null>(null)
    const [isOpen, setIsOpen] = useState(false)

    // rowKey es el registro_id de la fila, lo envía la tabla en su evento goTo
    const openDetail = (rowKey: string) => {
        const row = rows?.find((r) => r.registro_id === rowKey)
        if (!row) {
            return
        }
        setSelectedRow(row)
        setIsOpen(true)
    }

    const closeDetail = () => setIsOpen(false)

    // Al cambiar los registros (página, filtros, orden o rango de fechas) el detalle abierto ya no corresponde
    useEffect(() => {
        setIsOpen(false)
    }, [rows])

    return {
        selectedRow,
        isOpen,
        openDetail,
        closeDetail,
    }
}

export default useRegistroHuespedesDetail
